<template>
    <!-- Modal Detail User -->
    <CModal
    title="Modal title"
    :show.sync="modalDetailPembatalan"
    :no-close-on-backdrop="true"
    :centered="true"
    >
    <CRow>
        <div class="modal-body row my-n3">
            <div class="col-5">
                <p class="font-weight-bold">Nama Anggota</p>
                <p class="font-weight-bold">Nama Sertifikasi</p>
                <p class="font-weight-bold">Kategori Anggota</p>
                <p class="font-weight-bold">No. Handphone</p>
                <p class="font-weight-bold">No. Telepon</p>
                <p class="font-weight-bold">Email</p>
                <p class="font-weight-bold">Bank</p>
                <p class="font-weight-bold">Nama Rekening</p>
                <p class="font-weight-bold">No. Rekening</p>
                <p class="font-weight-bold">Bukti Refund</p>
                
            </div>
            <div class="col-7">
                <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
                <p>: {{ formData.nama_sertifikasi ? formData.nama_sertifikasi : ' - ' }}</p>
                <p>: {{ formData.kategori_anggota ? formData.kategori_anggota : ' - ' }}</p>
                <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
                <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
                <p>: {{ formData.email ? formData.email : ' - ' }}</p>
                <p>: {{ formData.nama_bank ? formData.nama_bank : ' - ' }}</p>
                <p>: {{ formData.nama_rekening ? formData.nama_rekening : ' - ' }}</p>
                <p>: {{ formData.no_rekening ? formData.no_rekening : ' - ' }}</p>
                <p>: <button 
                    :class="formData.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                    :disabled="formData.file_bukti_refund === null" 
                    @click="lihatFile(formData.file_bukti_refund)">
                    Lihat File
                    </button>
                </p>
                
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="" class="font-weight-bold">Alasan</label>
                    <textarea  
                    class="form-control"
                        cols="30"
                        readonly
                        v-model="formData.keterangan" 
                        rows="5">
                    </textarea>
                </div>
                <div class="form-group">
                    <label for class="font-weight-bold">Status</label>
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                          v-model="formData.status_pembatalan"
                        />
                        <label class="custom-control-label" for="aktif">Disetujui</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="2"
                          v-model="formData.status_pembatalan"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Ditolak</label>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </CRow>
    <template #header>
        <h6 class="modal-title h5 font-weight-bold">Detail Pembatalan</h6>
    </template>
    <template #footer>
        
        <CButton color="info" @click="postStatusPembatalan">Simpan</CButton>
        
        <CButton @click="modalDetailPembatalan = false" color="danger">Tutup</CButton>
    </template>
    </CModal>
    <!-- End Modal -->
</template>
<script>

export default {
    name: 'Modal',
    data() {
        return {
        }
    },
    components : {
    },
    props: [
        'modalDetailPembatalan',
        'title',
        'formData'
    ],

    watch: {
        modalDetailPembatalan: function(val) {
            if(!this.modalDetail) {                
                this.$emit('closeModalPembatalan', val)
            }            
        }
    },

    mounted() {
      
    },
    methods : {
        postStatusPembatalan() {
            this.$parent.postStatusPembatalan(this.formData);
        }
    },
    computed: {
      
    }
}
</script>